export default "__VITE_ASSET__BawHlRA$__"